import * as React from "react";

import { Link, useLocation } from "react-router-dom";

import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import BookmarksOutlinedIcon from "@material-ui/icons/BookmarksOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import { Box, IconButton, makeStyles, Theme, Tooltip } from "@material-ui/core";

import { User } from "../Utility/User";

import { AccountRoute, FavoritesRoute, HomeRoute, IRoute, QuiltBotRoute, Routes } from "../Routes";

export interface IProps {
    readonly user: User;
}

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        padding: 0
    },

    marginLeftButton: {
        padding: 0,
        marginLeft: theme.spacing(3)
    }
}));

function getActiveRoute(pathname: string): IRoute | null {
    for (const route of Routes) {
        if (route.path.localeCompare(pathname, undefined, { sensitivity: "base" }) === 0) {
            return route;
        }
    }

    return null;
}

function getColor(route: IRoute, activeRoute: IRoute | null): "primary" | "action" {
    return route === activeRoute ? "primary" : "action";
}

export function TopAppBar(props: IProps): React.ReactElement {
    const classes = useStyles();
    const location = useLocation();

    const activeRoute = getActiveRoute(location.pathname);

    return (
        <Box display="flex" flexDirection="row" justifyContent="center" style={{ width: "100%" }}>
            <Tooltip title="Home">
                <IconButton component={Link} to={HomeRoute.path} className={classes.button}>
                    <HomeOutlinedIcon color={getColor(HomeRoute, activeRoute)} fontSize="large" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Quilt of the Day">
                <IconButton component={Link} to={QuiltBotRoute.path} className={classes.marginLeftButton}>
                    <CalendarTodayOutlinedIcon color={getColor(QuiltBotRoute, activeRoute)} fontSize="large" />
                </IconButton>
            </Tooltip>
            {props.user !== undefined &&
                <Tooltip title="Saved quilts">
                    <IconButton component={Link} to={FavoritesRoute.path} className={classes.marginLeftButton}>
                        <BookmarksOutlinedIcon color={getColor(FavoritesRoute, activeRoute)} fontSize="large" />
                    </IconButton>
                </Tooltip>
            }

            {/*<Tooltip title="Account">
                <IconButton component={Link} to={AccountRoute.path} className={classes.marginLeftButton}>
                    <AccountCircleOutlinedIcon color={getColor(AccountRoute, activeRoute)} fontSize="large"/>
                </IconButton>
            </Tooltip>*/}
        </Box>
    )
}